import { Alert } from '@backstage/ui';

import { GraphQLAppError } from '@spotify/confidence-graphql';

import { useDialogContext } from './context';

export const SubmitErrorBui = () => {
  const { error } = useDialogContext();
  if (!error) return null;
  const title =
    error instanceof GraphQLAppError
      ? (error.enrichedMessage ?? error.message)
      : error.message;
  return <Alert status="danger" icon title={title} />;
};

SubmitErrorBui.displayName = 'DialogCompositeBui.SubmitError';

export default SubmitErrorBui;
